import axios from 'axios'
import qs from 'qs'

// import store from '@/store'
import { Toast, Dialog } from 'vant'
// 根据环境不同引入不同api地址
import { baseApi } from '@/config'
const serviceNoDialog = axios.create({
    baseURL: baseApi, // url = base api url + request url
    withCredentials: true, // send cookies when cross-domain requests
    // timeout: 5000 // request timeout
})

// request拦截器 request interceptor
serviceNoDialog.interceptors.request.use(
    config => {
        if (config.method === 'post') {
            config.data = qs.stringify(config.data, { indices: false })
        }
        // 不传递默认开启loading
        if (!config.hideloading) {
            // loading
            Toast.loading({
                forbidClick: true
            })
        }
        return config
    },
    error => {
        // do something with request error
        console.log(error) // for debug
        return Promise.reject(error)
    }
)
// respone拦截器
serviceNoDialog.interceptors.response.use(
    response => {
        Toast.clear()
        const res = response.data
        if (res.status == 0) {
            return Promise.resolve(res)
        } 
        else if (res.status == 2) {// 登录超时,重新登录
            let _type = window.H.getParam("type")
            if (!_type || _type == null) {
                if (!localStorage.getItem('wxcodebase')) {
                    sessionStorage.setItem('url', location.href)
                    // let url = 'https://' + window.location.host + '/codeBase.html'
                    var a = document.createElement("a")
                    a.setAttribute("href", "codeBase.html")
                    var url = a.href
                    location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx9bb981b64f9933ee&redirect_uri=' + url + '&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect'
                } else {
                    return Promise.reject(res || 'error')  
                }
            } else {
                return Promise.reject(res || 'error')
            }
        } 
        else {
            return Promise.reject(res || 'error')
        }
    },
    error => {
        Toast.clear()
        console.log('err' + error) // for debug
        Dialog.alert({ message: '请求失败' }).then(() => { })
        return Promise.reject(error)
    }
)
export default serviceNoDialog